import React from "react";
import styled, { css } from "styled-components";
import { ArrowIcon } from "@ui/components/icons";
import { LoadingButton, LoadingButtonProps } from "./loadingButton";

interface NextButtonProps extends LoadingButtonProps {
	inverted?: boolean;
	bgColor?: string;
	marginBottom?: number;
}

export const NextButton: React.FC<NextButtonProps> = ({ bgColor, marginBottom, ...htmlProps }) => {
	return (
		<Button marginBottom={marginBottom} bgColor={bgColor} {...htmlProps}>
			<ArrowIcon />
		</Button>
	);
};

const Button = styled(LoadingButton).withConfig({
	shouldForwardProp: (prop) => !["inverted", "bgColor", "marginBottom"].includes(prop),
})<{ inverted?: boolean; bgColor?: string; marginBottom?: number }>`
	padding: 12px;
	border-radius: 24px;
	background-color: ${({ theme, bgColor }) => (!bgColor ? theme.colors.secondaryLight : bgColor)};
	${({ marginBottom }) => (marginBottom ? "margin-bottom:" + marginBottom + "px !important;" : undefined)};
	svg path {
		fill: ${({ theme }) => theme.colors.secondary};
	}
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondaryLight};
	}
	${({ inverted }) =>
		!inverted &&
		css`
			transform: scaleX(-1);
			background-color: ${({ theme }) => theme.colors.secondary};
			&:hover {
				background-color: ${({ theme }) => theme.colors.secondary};
			}
			svg path {
				fill: ${({ theme }) => theme.colors.white};
			}
		`};
`;
